<template lang="pug">
	div
		.modal(:class="{'modal_active': isModalActive}")
			.modal__inner
				.row
					.column(v-html="settings.fake_protection_first_content")
					.column(v-html="settings.fake_protection_second_content")
				.row
					img(:src="settings.fake_protection_first_image")
					img(:src="settings.fake_protection_second_image")
				button.modal__close(@click="isModalActive = false")

		.page
			.wrapper.wrapper_max
				router-link.back(data-aos="fade-up" data-aos-delay="200" :style="{backgroundColor: getCategoryBySlug($route.params.category) ? getCategoryBySlug($route.params.category).color : '#fff'}" :to="'/products/' + $route.params.category + '/'") {{ getCategoryBySlug($route.params.category) ? getCategoryBySlug($route.params.category).name : '' }}
					span
			.wrapper
				.product
					.poster
						.poster__image(data-aos="fade" :style="{backgroundImage: 'url(\"'+ (page.visual ? page.visual[1200] : page.background_link) +'\")'}")
						.poster__content(data-aos="fade-up" data-aos-delay="200")
							.poster__title(v-text="page.name")
							.poster__subtitle(v-text="page.purpose")
							.poster__text(v-text="page.short_description" :style="{'white-space': 'pre-line'}")
							a.poster__label(:href="page.buy_link" target="_blank") Де придбати
						.poster__links
							//- a.poster__label(v-if="page.visual" :href="page.visual" target="_blank") Віжуал препарату
							a.poster__label.poster__label_3(data-aos="fade-up" data-aos-delay="200" v-if="page.pdf_presentation_link" :href="page.pdf_presentation_link" target="_blank") Презентація
								span
							a.poster__label.poster__label_2(data-aos="fade-up" data-aos-delay="200" v-if="page.pdf_passport_link" :href="page.pdf_passport_link" @click="addAnalyticEvent" target="_blank") Паспорт
								span
							a.poster__label.poster__label_4(data-aos="fade-up" data-aos-delay="200" v-if="page.booklet_link" :href="page.booklet_link" target="_blank") Буклет
								span
					.info(data-aos="fade-up" :class="{'three-btns': page.pdf_presentation_link && page.pdf_passport_link && page.booklet_link, 'two-btns': (page.pdf_presentation_link && page.pdf_passport_link) || (page.pdf_presentation_link && page.booklet_link) || (page.pdf_passport_link && page.booklet_link) }")
						.card(v-if="page.active_substance")
							.card__param Діюча речовина
							.card__value(v-text="page.active_substance")
						.card(v-if="page.form_of_use")
							.card__param Препаративна форма
							.card__value(v-text="page.form_of_use")
						.card(v-if="page.norm_of_use")
							.card__param Норма використання
							.card__value(v-text="page.norm_of_use")
						.card(v-if="page.chemical_class")
							.card__param Хімічний клас
							.card__value(v-text="page.chemical_class")
						.card(v-if="page.boxing")
							.card__param Упаковка
							.card__value(v-text="page.boxing")
						.card(v-if="page.toxicity_class")
							.card__param Клас токсичності
							.card__value(v-text="page.toxicity_class")
						.card(v-if="page.shelf_life")
							.card__param Термін зберігання
							.card__value(v-text="page.shelf_life")
					.section.section_sec(data-aos="fade-up" v-if="settings.product_app_image && settings.product_app_title")
						.apps
							.apps__inner
								.apps__content
									.apps__subtitle(v-text="settings.product_app_subtitle")
									.apps__title(v-text="settings.product_app_title")
									.apps__text(v-html="settings.product_app_content")
								img.apps__img(:src="settings.product_app_image")
								.apps__list
									a.apps__item(v-if="settings.product_app_link_ios" :href="settings.product_app_link_ios" target="_blank" @click="sendAnalyticIos")
										img(src="@/assets/img/app1.svg")
									a.apps__item(v-if="settings.product_app_link_android" :href="settings.product_app_link_android" target="_blank" @click="sendAnalyticAndroid")
										img(src="@/assets/img/app2.svg")
						.apps.apps_mobile
							.apps__inner
								.apps__subtitle(v-text="settings.product_app_subtitle")
								.apps__title(v-text="settings.product_app_title")
								.apps__text(v-html="settings.product_app_content")
								.apps__content
									img.apps__img(:src="settings.product_app_image")
									.apps__list
										a.apps__item(v-if="settings.product_app_link_ios" :href="settings.product_app_link_ios" target="_blank"  @click="sendAnalyticIos")
											img(src="@/assets/img/app1.svg")
										a.apps__item(v-if="settings.product_app_link_android" :href="settings.product_app_link_android" target="_blank" @click="sendAnalyticAndroid")
											img(src="@/assets/img/app2.svg")
					.tabs
						.tabs__head(data-aos="fade-up")
							button.tabs__button(:class="{'tabs__button_active': activeTab === 1}" @click="activeTab = 1") Характеристика
							button.tabs__button(:class="{'tabs__button_active': activeTab === 2}" @click="activeTab = 2") Реєстрація
							button.tabs__button(:class="{'tabs__button_active': activeTab === 3}" @click="activeTab = 3") Рекомендації
							button.tabs__button(:class="{'tabs__button_active': activeTab === 0}" @click="activeTab = 0") Упаковка
						.tabs__body(data-aos="fade-up" data-aos-delay="200")
							.tabs__tab(v-show="activeTab === 0")
								.box
									.box__column
										.box__title(v-text="page.name")
										.box__info(v-text="page.boxing")
									.box__column.box__column_center
										img(:src="page.boxing_link ? page.boxing_link[400] : ''")
									button.box__label(@click="isModalActive = true") Захист від підробок
							.tabs__tab(v-show="activeTab === 1")
								.text(v-html="page.characteristics_p")
							.tabs__tab(v-show="activeTab === 2")
								.table-container
									table(v-if="page.registration && page.registration.length")
										tr.tr_heading
											td Культура
											td(v-for="(td, i) in page.registration[0].specs" :key="i" v-text="td.title")
										tr(v-for="(row, index) in page.registration" :key="index")
											td(v-text="row.name")
											td(v-for="(td, i) in row.specs" :key="i" v-text="td.content")
									.sensitive(v-if="page.sensitive_weeds || page.medium_sensitive_weeds")
										.sensitive__column
											.sensitive__title Чутливі бур’яни
											.sensitive__items(v-html="page.sensitive_weeds")
										.sensitive__column
											.sensitive__title Середньочутливі бур’яни
											.sensitive__items(v-html="page.medium_sensitive_weeds")
							.tabs__tab(v-show="activeTab === 3")
								.text(v-html="page.recommendations_p")
					.tabs.tabs_mobile
						.part(v-if="page.characteristics_p")
							button.tabs__button(:class="{'tabs__button_active': activeTab === 1}" @click="onClickBtn($event, activeTab === 1 ? -1 : 1)") Характеристика
								span
							slide-up-down(:active="activeTab === 1" :duration="300")
								.tabs__tab
									.box
										.text(v-html="page.characteristics_p")
						.part
							button.tabs__button(:class="{'tabs__button_active': activeTab === 2}" @click="onClickBtn($event, activeTab === 2 ? -1 : 2)") Реєстрація
								span
							slide-up-down(:active="activeTab === 2" :duration="300")
								.tabs__tab
									.box
										.table-container
											table(v-if="page.registration && page.registration.length && !desk" v-for="t in page.registration")
												tr.tr_heading
													td( v-text="t.name")
												tr( v-for="td in t.specs")
													td
														span(v-text="td.title")
														span(v-text="td.content || ''")
											.sensitive(v-if="page.sensitive_weeds || page.medium_sensitive_weeds")
												.sensitive__column
													.sensitive__title Чутливі бур’яни
													.sensitive__items(v-html="page.sensitive_weeds")
												.sensitive__column
													.sensitive__title Середньочутливі бур’яни
													.sensitive__items(v-html="page.medium_sensitive_weeds")
						.part(v-if="page.recommendations_p")
							button.tabs__button(:class="{'tabs__button_active': activeTab === 3}" @click="onClickBtn($event, activeTab === 3 ? -1 : 3)") Рекомендації
								span
							slide-up-down(:active="activeTab === 3" :duration="300")
								.tabs__tab
									.box
										.text(v-html="page.recommendations_p")
						.part
							button.tabs__button(:class="{'tabs__button_active': activeTab === 0}" @click="onClickBtn($event, activeTab === 0 ? -1 : 0)") Упаковка
								span
							slide-up-down(:active="activeTab === 0" :duration="300")
								.tabs__tab
									.box
										.box__column
											.box__title(v-text="page.name")
											.box__info(v-text="page.boxing")
										.box__column
											img(:src="page.boxing_link ? page.boxing_link[400] : ''")
										button.box__label(@click="isModalActive = true") Захист від підробок
					.cultures
						.cultures__title(data-aos="fade-up") Пов’язані культури
						.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
							.cultures__swiper-wrapper
								swiper.cultures__swiper( ref="swiper1" v-if="showSliders && page.cultures && page.cultures.length" :options="{allowTouchMove: false,loop: (!(getCulturesByIds(page.cultures) && getCulturesByIds(page.cultures).length <= 4)),slidesPerView: 4, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
									swiperSlide(
										v-for="(card, index) in getCulturesByIds(page.cultures)"
										:key="index"
									)
										section-card(
											:card="card"
											:type="'culture'"
											:link="'/cultures/' + card.slug + '/'"
										)
							template(v-if="getCulturesByIds(page.cultures) && getMaterialsByProduct(page.id).length > 4")
								button.cultures__arrow.cultures__arrow_left( @click="slidePrev(1)")
								button.cultures__arrow.cultures__arrow_right( @click="slideNext(1)")
						.cultures__bottom(data-aos="fade-up")
							router-link.cultures__more(to='/cultures/') Всі культури
								span
					.cultures.cultures_last
						.cultures__title(data-aos="fade-up") Пов’язані матеріали
						.cultures__swiper-container(data-aos="fade-up" data-aos-delay="200")
							.cultures__swiper-wrapper
								swiper.cultures__swiper(ref="swiper2" v-if="showSliders && page.id && page.materials" :options="{allowTouchMove: false,loop: (!(getMaterialsByProduct(page.id) && getMaterialsByProduct(page.id).length <= 4)),slidesPerView: 4, breakpoints: {1200: {slidesPerView: 'auto',allowTouchMove: true}}}")
									swiperSlide(
										v-for="(card, index) in page.materials"
										:key="index"
									)
										section-card(
											:card="card"
											:type="'new_min'"
											:link="'/'+(card.type === 'Новини' ? 'news' : card.type === 'Статті' ? 'articles' : card.type === 'Акції' ? 'promos' : 'video')+'/' + card.slug + '/'"
										)
							template(v-if="page.materials && page.materials.length > 4")
								button.cultures__arrow.cultures__arrow_left.cultures__arrow_b( @click="slidePrev(2)")
								button.cultures__arrow.cultures__arrow_right.cultures__arrow_b( @click="slideNext(2)")
			.nav(v-if="siblingsCards.prev && siblingsCards.next" data-aos="fade-up")
				.wrapper
					.nav__block
						.nav__title Попередній продукт
						router-link.nav__card(:to="'/products/' + $route.params.category + '/' + siblingsCards.prev.slug + '/'" :style="{backgroundImage: 'url(\"'+ siblingsCards.prev.background_link[1200] +'\")'}")
							.nav__name(v-text="siblingsCards.prev.name")
							.nav__subtitle(v-text="siblingsCards.prev.purpose")
					.nav__block
						.nav__title Наступний продукт
						router-link.nav__card(:to="'/products/' + $route.params.category + '/' + siblingsCards.next.slug + '/'" :style="{backgroundImage: 'url(\"'+ siblingsCards.next.background_link[1200] +'\")'}")
							.nav__name(v-text="siblingsCards.next.name")
							.nav__subtitle(v-text="siblingsCards.next.purpose")

</template>

<script>

	let collectionSlug = 'products';

	import sectionCard from '@/components/sectionCard.vue';

	import AOS from 'aos';

	import 'swiper/dist/css/swiper.css'
	import { swiper, swiperSlide } from 'vue-awesome-swiper'

	import {mapState, mapGetters} from 'vuex';
	import SlideUpDown from 'vue-slide-up-down';

	export default {
		name: 'Product',
		metaInfo: function() {
			let th = this;

			return {
				title: 'Продукти — ' + th.page.name
			}
		},
		data: function(){
			return {
				page: {},
				activeTab: 1,
				isModalActive: false,
				siblingsCards: {},
				showSliders: true,
				swiperCulturesOption: {
					allowTouchMove: false,
					loop: true,
					slidesPerView: 4,
					navigation: {
						nextEl: '.cultures__arrow_right',
						prevEl: '.cultures__arrow_left'
					},
					breakpoints: {
						1200: {
							slidesPerView: 'auto',
							allowTouchMove: true
						}
					}
				},
			}
		},
		created() {
			if (!this[collectionSlug].length) this.$store.dispatch('GET_COLLECTION', collectionSlug);
			if (!this.catalogs.length) this.$store.dispatch('GET_COLLECTION', 'catalogs');
			if (!this.cultures.length) this.$store.dispatch('GET_COLLECTION', 'cultures');
			if (!this.news.length) this.$store.dispatch('GET_COLLECTION', 'news');
			if (!this.articles.length) this.$store.dispatch('GET_COLLECTION', 'articles');
			if (!this.promos.length) this.$store.dispatch('GET_COLLECTION', 'promos');
      if (!this.videos.length) this.$store.dispatch('GET_COLLECTION', 'videos');
		},
		mounted() {
			let data = this.getProductBySlug(this.$route.params.slug);
			if (data) {
				this.page = data;
				this.siblingsCards = this.getSiblings(data.id, data.catalogs[0]);
			}
			window.addEventListener('resize', this.resizeHandler, false);

			this.$nextTick(() => {
				AOS.init({
					once: true,
					disabled: 'mobile',
					duration: 1000
				});
			})
		},
		destroyed() {
			window.removeEventListener('resize', this.resizeHandler, false);
		},
		components: {
			'section-card': sectionCard,
			'slide-up-down': SlideUpDown,
			swiper,
			swiperSlide,
		},
		methods: {
		  addAnalyticEvent() {
              dataLayer.push({
                'eventCategory':'passport',
                'eventAction':'Click',
                'eventLabel':'product_passport_download',
                'event':'product_passport_download'
              })
          },
			resizeHandler() {
				setTimeout(() => {
					if (this.$refs.swiper1) this.$refs.swiper1.swiper.update();
					if (this.$refs.swiper2) this.$refs.swiper2.swiper.update();
				});
			},
			onClickBtn(e, i) {
				let el = e.currentTarget;
				this.activeTab = i;
				setTimeout(() => {
					let top = el.offsetTop;
					window.scrollTo({
						top: top-70,
						behavior: "smooth"
					});
				}, 300);
			},
			slideNext(id) {
				if(id == 1) this.$refs.swiper1.swiper.slideNext();
				if(id == 2) this.$refs.swiper2.swiper.slideNext();
			},
			slidePrev(id) {
				if(id == 1 ) this.$refs.swiper1.swiper.slidePrev();
				if(id == 2 ) this.$refs.swiper2.swiper.slidePrev();
			},
      sendAnalyticAndroid() {
        dataLayer.push({
          'eventCategory':'application',
          'eventAction':'Click',
          'eventLabel':'app_android',
          'event':'app_android'
        });
      },
      sendAnalyticIos() {
        dataLayer.push({
          'eventCategory':'application',
          'eventAction':'Click',
          'eventLabel':'app_ios',
          'event':'app_ios'
        });
      },
		},
		computed: {
			...mapState([
				collectionSlug,
				'catalogs',
				'cultures',
				'news',
				'articles',
				'promos',
				'settings',
				'videos',
				'desk',
			]),
			...mapGetters([
				'getCategoryBySlug',
				'getProductBySlug',
				'getCulturesByIds',
				'getSiblings',
				'getMaterialsByProduct'
			])
		},
		watch: {
			products() {
				if (this.products && this.products.length) {
					this.page = this.getProductBySlug(this.$route.params.slug);
					this.siblingsCards = this.getSiblings(this.page.id, this.page.catalogs[0]);
				}
			},
			$route() {
				let data = this.getProductBySlug(this.$route.params.slug);
				if (data) {
					this.page = data;
					this.siblingsCards = this.getSiblings(data.id, data.catalogs[0]);
				}
			},
		}
	}

</script>

<style lang="scss" scoped>

	@import '@/helpers/sass/kit.scss';

	>>> .page {
		margin-top: 0;
	}

	.sensitive {
		width: 100%;
		text-align: center;
		margin-top: 50px;

		&__title {
			font: 700 14px/1.3 'Helvetica', Arial, sans-serif;
			letter-spacing: .5px;
			margin-bottom: 4px;
		}

		&__column {
			text-align: left;
			display: inline-block;
			vertical-align: top;
			width: 100%;
			max-width: 304px;
			margin: 0 8px;
		}

		&__items {
			white-space: pre;
			font: 300 14px/1.9 'Helvetica', Arial, sans-serif;
			letter-spacing: .5px;
		}
	}

	.modal {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(#fff, .8);
		z-index: 10;
		text-align: center;
		overflow: auto;
		padding: 50px 0;
		opacity: 0;
		pointer-events: none;
		visibility: hidden;
		transition: opacity .5s ease, visibility .5s ease;

		&_active {
			opacity: 1;
			visibility: visible;
			pointer-events: all;
		}

		&__close {
			position: absolute;
			right: 0;
			top: 0;
			width: 50px;
			height: 50px;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.2);
			background: url('../assets/img/close.svg') #fff no-repeat center center;
			z-index: 1;
		}

		&:before {
			content: "";
			display: inline-block;
			vertical-align: middle;
			height: 100%;
		}

		&__inner {
			display: inline-block;
			vertical-align: middle;
			max-width: 886px;
			padding: 20px;
			background-color: #fff;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			position: relative;
			text-align: left;
			width: 100%;
		}

		>>> &__title {
			font: 700 21px/31px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
		}

		>>> h1 {
			font: 700 21px/31px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
			margin-bottom: 12px;
		}

		>>> h2 {
			font: 700 14px/21px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
			margin-bottom: 12px;
		}

		&__subtitle {
			font: 700 14px/31px 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
		}

		>>> &__text {
			font: 300 14px/16px 'Helvetica', Arial, sans-serif;

			>>> ul {
				list-style-type: disc;
				list-style-position: inside;

				>>> li {
					margin-bottom: 10px;
				}
			}
		}

		.row {
			font-size: 0;

			&:nth-child(1) {
				.column {
					display: inline-block;
					vertical-align: top;

					&:nth-child(2) {
						width: 305px;
					}

					&:nth-child(1) {
						width: calc(100% - 305px);
						padding-right: 15px;

						>>> .modal__text {
							padding-right: 20px;
						}
					}
				}
			}

			&:nth-child(2) {
				text-align: right;

				>>> img {
					display: inline-block;
					vertical-align: middle;
				}
			}
		}
	}

	.back {
		text-transform: uppercase;
		display: inline-block;
		height: 50px;
		background-color: #fff;
		box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		font: 500 19px/50px 'Helvetica', Arial, sans-serif;
		color: #333333;
		padding: 2px 29px 0 78px;
		letter-spacing: 2px;
		position: relative;
		z-index: 2;
		color: #fff;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;

		&:after {
			content: "";
			display: block;
			position: absolute;
			width: calc(100% - 50px);
			height: 100%;
			top: 0;
			right: 0;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.1);
		}

		span {
			display: block;
			position: absolute;
			width: 50px;
			height: 100%;
			top: 0;
			left: 0;
			background: url('../assets/img/back.svg') no-repeat center center;
			transition: transform .5s ease;
			transform: translate3d(0, 0, 1px);
		}

		&:hover {
			span {
				transform: translate3d(-5px, 0, 1px);
			}
		}
	}

	.poster {
		height: 518px;
		width: 100%;
		position: relative;
		margin-top: -50px;

		&__image {
			background-size: cover;
			background-position: center;
			position: absolute;
			top: 0;
			right: 0;
			width: calc(100% - 327px);
			height: 100%;
		}

		&__content {
			position: absolute;
			background-color: #fff;
			top: 50px;
			padding: 80px 108px 77px 108px;
			width: 630px;
			left: 0;
			z-index: 1;
			position: relative;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
		}

		&__label {
			position: absolute;
			top: calc(100% - 30px);
			left: 108px;
			background-color: #EF3E33;
			height: 30px;
			padding: 0 30px;
			font: 500 11px/30px 'Helvetica', Arial, sans-serif;
			color: #fff;
			text-transform: uppercase;
			letter-spacing: 1px;
			box-shadow: 0px 6px 10px rgba(51, 51, 51, 0.2);
      text-align: center;

			&:hover {
				opacity: .7!important;
				transition: opacity .3s ease;
			}

			span {
				width: 30px;
				height: 100%;
				position: absolute;
				top: 0;
				right: 0;
				background: url('../assets/img/dwn.svg') no-repeat center center;
			}

			&_2 {
				display: inline-block;
				vertical-align: top;
				position: absolute;
				top: 100%;
				right: 80px;
				width: 197px;
				left: auto;

				&:after {
					content: "";
					display: block;
					position: absolute;
					width: calc(100% - 30px);
					height: 100%;
					top: 0;
					left: 0;
					box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
				}
			}

			&_3 {
				display: inline-block;
				vertical-align: top;
				position: absolute;
				top: 100%;
				right: 297px;
				width: 197px;
				left: auto;

				&:after {
					content: "";
					display: block;
					position: absolute;
					width: calc(100% - 30px);
					height: 100%;
					top: 0;
					left: 0;
					box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
				}
			}

			&_4 {
				display: inline-block;
				vertical-align: top;
				position: absolute;
				top: 100%;
				right: 514px;
				width: 197px;
				left: auto;

				&:after {
					content: "";
					display: block;
					position: absolute;
					width: calc(100% - 30px);
					height: 100%;
					top: 0;
					left: 0;
					box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
				}
			}
		}

		&__title {
			@include kit('featureTitle');
			margin-top: 0;
		}

		&__subtitle {
			@include kit('featureSubtitle');
			margin-top: 13px;
		}

		&__text {
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;
			margin-top: 21px;
		}
	}

	.info {
		margin-top: 80px;

		.card {
			font-size: 0;
			margin-bottom: 12px;

			&__param {
				display: inline-block;
				vertical-align: top;
				width: 327px;
				font: 300 14px/18px 'Helvetica', Arial, sans-serif;
				letter-spacing: .5px;
				padding-left: 108px;
				padding-right: 20px;
			}

			&__value {
				display: inline-block;
				vertical-align: top;
				width: calc(100% - 327px);
				font: 500 14px/18px 'Helvetica', Arial, sans-serif;
				letter-spacing: .5px;
			}
		}
	}

	.tabs {
		margin-top: 50px;

		&_mobile {
			display: none;
		}

		&__head {
			margin: 0 -10px;
		}

		&__button {
			width: 305px;
			height: 50px;
			text-align: center;
			background-color: #fff;
			font: 500 19px 'Helvetica', Arial, sans-serif;
			text-transform: uppercase;
			margin: 0 10px;
			letter-spacing: 1px;
			transition: color .5s ease, background-color .5s ease;

			&_active {
				background-color: #EF3E33;
				color: #fff;
				box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			}
		}

		&__tab {
			padding-top: 55px;
			padding-bottom: 50px;
		}

		.text {
			max-width: 630px;
			margin: auto;
			font: 300 14px/18px 'Helvetica', Arial, sans-serif;
			white-space: pre-line;

			>>> p {
				margin: 10px 0;
			}
		}
	}

	.apps {
		margin: 124px 0 193px;

		&_mobile {
			display: none;
		}

		&__inner {
			background-color: #fff;
			box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
			padding: 84px 0 69px 107px;
			position: relative;
		}

		&__img {
			position: absolute;
			width: 50%;
			max-width: 630px;
			right: 0;
			top: 50%;
			transform: translateY(-44%);
		}

		&__content {
			max-width: 50%;
		}

		&__subtitle {
			@include kit('featureSubtitle');
		}

		&__title {
			@include kit('featureTitle');
		}

		&__text {
			@include kit('featureText');
			height: 62px;
			overflow: hidden;
		}

		&__list {
			position: absolute;
			bottom: 100%;
			left: 0;
			font-size: 0;
		}

		&__item {
			display: inline-block;
			vertical-align: top;
			margin-right: 20px;
			transition: opacity .5s ease;

			@media screen and (min-width: 1201px) {
				&:hover {
					opacity: .7;

				}
			}

			img {
				max-width: 88px;
			}
		}
	}

	.box {
		position: relative;

		&__title {
			font: 700 21px/21px 'Helvetica', Arial, sans-serif;
			margin-bottom: 42px;
		}

		&__column {
			&:nth-child(1) {
				display: inline-block;
				vertical-align: top;
				width: 327px;
				font: 500 14px/20px 'Helvetica', Arial, sans-serif;
				letter-spacing: .5px;
				padding-left: 108px;
				padding-right: 20px;
			}

			&:nth-child(2) {
				display: inline-block;
				vertical-align: top;
				width: calc(100% - 330px);
				font: 500 14px/20px 'Helvetica', Arial, sans-serif;
				letter-spacing: .5px;
				padding-right: 327px;

				img {
					max-height: 300px;
				}
			}

			&_center {
				text-align: center;
			}
		}

		&__label {
			position: absolute;
			bottom: 0;
			left: 0;
			background-color: #EF3E33;
			height: 30px;
			padding: 0 30px;
			font: 500 11px/30px 'Helvetica', Arial, sans-serif;
			color: #fff;
			text-transform: uppercase;
			letter-spacing: 1px;
			box-shadow: 0px 6px 10px rgba(51, 51, 51, 0.2);
		}
	}

	.table-container {
		overflow: auto;
	}

	table {
		width: 100%;
		table-layout: fixed;
		border-collapse: collapse;
		min-width: 1000px;
	}

	td {
		border: 2px solid #F2F2F2;
		background-color: #fff;
		width: calc(100%/7);
		vertical-align: middle;
		text-align: center;
		padding: 15px;
		min-height: 50px;
		letter-spacing: .9px;

		&:first-child {
			font-weight: 700;
		}
	}

	tr.tr_heading {
		td {
			background-color: transparent;
			font-weight: 700;
			vertical-align: top;
		}
	}

	.cultures {
		margin-top: 42px;
		margin-bottom: 100px;

		&_last {
			margin-bottom: 12px;
		}

		&__title {
			@include kit('sectionTitle');
			margin-left: 0;
			margin-top: 11px;
		}

		&__swiper {
			width: calc(100% + 20px);
			margin-left: -10px;
		}

		&__swiper-container {
			position: relative;
			margin-top: -29px;

		}

		&__swiper-wrapper {
			overflow: hidden;
			width: 100%;
			height: 100%;
		}

		&__arrow {
			position: absolute;
			top: 68px;
			width: 50px;
			height: 50px;
			box-shadow: 0px 10px 20px rgba(51, 51, 51, 0.2);
			background-color: #EF3E33;
			z-index: 0;

			&_left {
				background: url('../assets/img/arr_2.svg') #EF3E33 no-repeat center center;
				left: -49px;
			}

			&_right {
				background: url('../assets/img/arr_1.svg') #EF3E33 no-repeat center center;
				right: -49px;
			}

			&_b {
				top: 68.4px;
			}
		}

		>>> .card {
			margin-bottom: 57px;
			margin-top: 38px;
		}

		&__bottom {
			text-align: center;
			position: relative;
			z-index: 1;
		}

		&__more {
			height: 50px;
			width: 296px;
			max-width: 100%;
			border: 1px solid #EF3E33;
			position: relative;
			display: inline-block;
			vertical-align: top;
			text-transform: uppercase;
			margin-top: -6px;
			padding-right: 50px;
			text-align: center;
			color: #EF3E33;
			font: 500 19px/52px 'Helvetica', Arial, sans-serif;
			letter-spacing: 2px;
			position: relative;

			span {
				display: block;
				position: absolute;
				top: 0;
				right: 0;
				width: 50px;
				height: 100%;
				background: url('../assets/img/arr_3.svg') no-repeat center center;
				border-left: 1px solid #EF3E33;
			}
		}
	}

	.nav {
		font-size: 0;
		overflow: hidden;

		&__block {
			display: inline-block;
			vertical-align: top;
			width: 50%;
		}

		&__block:nth-child(2) {
			text-align: right;

			.nav__card {
				&:before {
					content: "";
					display: block;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: linear-gradient(to right, transparent 0%, rgba(0,0,0,.6) 100%);
				}
			}
		}

		&__block:nth-child(1) {
			.nav__card {
				margin-left: -80px;

				&:before {
					content: "";
					display: block;
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					background: linear-gradient(to right, rgba(0,0,0,.6) 0%,transparent 100%);
				}
			}
		}

		&__title {
			font: 700 21px/1 'Helvetica', Arial, sans-serif;
			letter-spacing: 1px;
		}

		&__card {
			display: block;
			height: 185px;
			background-color: #555;
			margin-top: 28px;
			background-size: cover;
			background-position: center;
			width: calc(100% + 80px);
			padding: 0 80px;
			padding-top: 83px;
			position: relative;
		}

		&__name {
			font: 700 21px/1 'Helvetica', Arial, sans-serif;
			color: #fff;
			letter-spacing: 1px;
			position: relative;
		}

		&__subtitle {
			font: 14px/1 'Helvetica', Arial, sans-serif;
			color: #fff;
			letter-spacing: 1px;
			position: relative;
		}
	}

	>>> .swiper-container {
		padding: 30px 0;
	}

	@media screen and (max-width: 1200px) {

		.sensitive {
			padding: 0 2px;

			&__column {
				max-width: 100%;
				margin: 0;
				margin-bottom: 50px;
			}
		}

		>>> .page {
			margin-top: 30px;
		}

		.tabs {
			display: none;

			&_mobile {
				display: block;
			}

			&__tab {
				padding-top: 20px;
				padding-top: 0;
				padding-bottom: 0;

				.box {
					padding-top: 20px;
					padding-bottom: 50px;
				}
			}

			&__button {
				margin: 0;
				width: 100%;
				position: relative;
				margin-bottom: 20px;
				padding-right: 50px;

				& + div {
					will-change: height;
				}

				span {
					display: block;
					position: absolute;
					top: 0;
					right: 0;
					width: 50px;
					height: 100%;
					box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.2);

					&:before {
						content: "";
						display: block;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						background: url('../assets/img/dropdown_white.svg') no-repeat center center;
						transition: transform .5s ease, opacity .5s ease;
						opacity: 0;
						transform: rotate(-180deg);
					}

					&:after {
						content: "";
						display: block;
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						background: url('../assets/img/dropdown.svg') no-repeat center center;
						transition: transform .5s ease, opacity .5s ease;
						opacity: 1;
					}
				}

				&_active {
					span {
						&:after {
							transform: rotate(180deg);
							opacity: 0;
						}

						&:before {
							transform: rotate(0);
							opacity: 1;
						}
					}
				}
			}
		}

		table {
			width: 100%;
			min-width: auto;
		}

		tr.tr_heading {
			td {
				font-size: 21px;
				line-height: 21px;
				letter-spacing: 1px;
				width: 100%;
				text-align: left;
				padding: 15px 15px 15px 0;
			}
		}

		td {
			padding: 7px 7px 7px 8px;
			span {
				font-weight: 300;
				text-align: left;
				display: block;
				&:first-child {
					font-weight: 700;
					margin-bottom: 4px;

				}
			}
		}

		.section_sec {
			margin: -90px 0;
		}

		.apps {
			display: none;

			&__list {
				height: 44px;
				box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.3);
			}

			&_mobile {
				display: block;
			}

			&__inner {
				background-color: transparent;
				padding: 0;
				width: 100%;
				box-shadow: none;
			}

			&__content {
				background-color: #fff;
				height: 274px;
				width: 100%;
				position: relative;
				top: 0;
				left: 0;
				max-width: none;
				margin-top: 233px;
				box-shadow: 0px 12px 20px rgba(51, 51, 51, 0.05);
				z-index: 1;
			}

			&__text {
				height: auto;
			}

			&__list {
				top: 100%;
				height: 30px;
			}

			&__img {
				height: 424px;
				width: auto;
				right: auto;
				left: 50%;
				top: auto;
				bottom: 42px;
				transform: translateX(-50%);
			}

			&__item {
				margin-right: 0;

				img {
					max-width: none;
					height: 30px;
				}
			}
		}

		.cultures {
			margin-top: 74px;

			&__title {
				margin-bottom: 41px;
			}

			&_last {
				margin-bottom: 68px;

				.cultures__title {
					margin-bottom: 37px;
				}
			}
			&__arrow {
				display: none;
			}

			&__more {
				margin-top: 20px;
			}

			.section__swiper-container {
				width: calc(100% + 40px);
				margin-left: 0px;
			}

			>>> .swiper-slide {
				padding: 0 10px;
				width: 266px;
			}

      >>> .card {
				width: 246px;
				margin: 0;
			}

			&__title {
				margin-bottom: 12px;
				margin-bottom: 38px;
			}

			& + .cultures_last {
				margin-top: -20px;
			}
		}

		.wrapper_max {
			padding: 0;
		}

		.poster {
			width: calc(100% + 40px);
			margin-left: -20px;
			margin-top: 0;
			height: auto;

			&__image {
				position: relative;
				height: 374px;
				width: 100%;
			}

			&__content {
				padding: 20px 20px 76px;
				margin-top: -50px;
				width: calc(100% - 40px);
				margin-left: 20px;
				display: block;
				top: 0;
			}

			&__links {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				height: max-content;
				position: relative;
			}

			&__label {
				right: 50%;
				transform: translateX(50%) !important;
				display: inline-block;
				width: 197px;
				left: auto;

				&_2 {
					top: 50px;
					padding: 0 50px 0 20px;
				}

				&_3 {
					top: 100px;
					padding: 0 33px 0 9px;
				}

				&_4 {
					top: 150px;
					padding: 0 33px 0 9px;
				}
			}

			&__subtitle {
				margin-top: 25px;
			}

			&__text {
				margin-top: 25px;
			}
		}

		.info {
			margin-top: 120px;

			&.three-btns {
				margin-top: 230px;
			}

			&.two-btns {
				margin-top: 170px;
			}

			.card {
				&__param {
					display: block;
					padding-left: 0;
					margin-right: 0;
				}

				&__value {
					display: block;
					padding-left: 0;
					width: 100%;
				}
			}
		}

		.box {

			&__label {
				display: none;
			}

			&__title {
				margin-bottom: 15px;
			}

			&__column {
				display: block;
				padding-left: 0;

				&:nth-child(1) {
					padding-left: 0;
					width: 100%;
					display: block;
				}

				&:nth-child(2) {
					width: 100%;
					padding: 0;
					text-align: center;
					margin-top: 35px;
				}
			}
		}

		.nav {
			&__block {
				&:nth-child(2) {

					.nav {
						&__title {
							float: right;
						}

						&__card {
							clear: both;
							padding: 42px 75px 0 0;
						}
					}

				}

				&:nth-child(1) {
					.nav {
						&__title {
							float: left;
						}

						&__card {
							clear: both;
							padding: 42px 0 0 75px;
						}
					}
				}
			}
			&__card {
				height: 130px;
				margin-top: 42px;
			}

			&__title {
				font-size: 14px;
				line-height: 18px;
				letter-spacing: 0.7px;
				max-width: 80%;
			}

			&__subtitle {
				margin-top: 8px;
			}
		}

		.modal {
			&__inner {
				padding-right: 40px;
			}
			.column {
				width: 100% !important;
			}

			>>> img {
				max-width: 100% !important;
				width: 100% !important;
				height: auto !important;
				display: block;
			}
		}
	}

</style>
